import api, { TokenManager } from "./api";

export const login = async (credentials) => {
  const response = await api.post("/api/token/", credentials);
  // response.data: {  access, refresh }
  // Optionally, fetch user info after login
  const userRes = await api.get("/api/user/", {
    headers: { Authorization: `Bearer ${response.data.access}` },
  });
  return {
    user: userRes.data,
    token: response.data.access,
    refresh: response.data.refresh,
  };
};

export const logout = async () => {
  // Clear tokens using TokenManager
  TokenManager.clearTokens();

  // Optionally call logout endpoint if your backend tracks active sessions
  try {
    await api.post("/api/logout/");
  } catch (error) {
    // Ignore logout endpoint errors since tokens are already cleared
    console.warn("Logout endpoint error (ignored):", error);
  }
};

export const getCurrentUser = async (token) => {
  const authToken = token || TokenManager.getAccessToken();
  if (!authToken) {
    throw new Error("No access token available");
  }

  const response = await api.get("/api/user/", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return response.data;
};
